module.exports = __webpack_public_path__ + "img/15-blog-login.8eee6a6a.webp";